<template>
  <mdb-navbar class="flexible-navbar white" position="top" double scrolling>
    <mdb-navbar-nav class="left-nav" right>
      <mdb-dropdown class="nav-item" tag="li">
        <mdb-dropdown-toggle
          slot="toggle"
          tag="li"
          outline="none"
          class="btn-transparent"
        >
          <mdb-icon icon="user" />
          <span class="clearfix d-none d-sm-inline-block">بیشتر</span>
        </mdb-dropdown-toggle>
        <mdb-dropdown-menu left>
          <mdb-dropdown-item @click="editProfile">پروفایل</mdb-dropdown-item>
          <mdb-dropdown-item @click="changePassword"
            >تغییر رمز عبور</mdb-dropdown-item
          >
          <mdb-dropdown-item @click="signout">خروج</mdb-dropdown-item>
        </mdb-dropdown-menu>
      </mdb-dropdown>

      <mdb-dropdown class="nav-item notifications-nav" tag="li">
        <mdb-dropdown-toggle
          slot="toggle"
          tag="li"
          outline="none"
          class="btn-transparent"
        >
          <mdb-badge
            color="red"
            v-show="countNotification > 0"
            v-text="countNotification"
          ></mdb-badge>
          <mdb-icon icon="bell" />
          <span class="d-none d-md-inline-block">اطلاعیه</span>
        </mdb-dropdown-toggle>
        <mdb-dropdown-menu>
          <mdb-dropdown-item
            @click="checkNotification(notification)"
            v-for="notification in notifications"
            :class="notification.Seen ? '' : 'seen-item'"
            v-bind:key="notification.NotificationId"
          >
            <span class="float-left">
              <mdb-icon
                class="notification-clock"
                icon="clock-o"
                arfaa-hidden="true"
                v-text="notification.LastUpdate"
              />
            </span>
            <div v-text="notification.Title"></div>
            <p class="limit-2-line-text" v-text="notification.Body"></p>
          </mdb-dropdown-item>
          
        </mdb-dropdown-menu>
      </mdb-dropdown>
    </mdb-navbar-nav>

    <mdb-navbar-toggler />

    <mdb-navbar-nav left>
      <mdb-breadcrumb>{{ computedPage.activePage }}</mdb-breadcrumb>
    </mdb-navbar-nav>

    <mdb-navbar-brand
      @click.native="toggleSideNav"
      class="button-collapse right-nav"
      ><mdb-icon icon="bars"
    /></mdb-navbar-brand>
    <span class="double-nav-right"></span>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbBreadcrumb,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbIcon,
  mdbBadge,
} from "mdbvue";

import { mapActions } from "vuex";
import { actionTypes, commitTypes, dbName } from "@/store-types";
import notificationApi from "@/api/notificationApi";

export default {
  name: "Navbar",
  props: {
    page: {
      type: String,
    },
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBreadcrumb,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbIcon,
    mdbBadge,
  },
  data() {
    return {
      activePage: this.page,
      toggle: false,
      notifications: null,
    };
  },
  methods: {
    ...mapActions(["toggleSideNav"]),
    signout: function () {
      this.$store.dispatch(actionTypes.CLEAR_LOGIN);
      this.$router.go(0);
    },
    editProfile: function () {
      this.$router.push({
        name: "EditProfile",
        params: { id: this.$store.state.user.UserId },
      });
    },
    changePassword: function () {
      this.$router.push({
        name: "ChangePassword",
        params: { id: this.$store.state.user.UserId },
      });
    },
    checkNotification: function (notification) {
      // console.log("checkNotification");
      notificationApi
        .seenNotification({ NotificationId: notification.NotificationId })
        .then(
          ({ data }) => {
            if (data.Status == 1) {
              // console.log('notification : ', notification.Type);
              notification.Seen = true;
              if (notification.Type == 1) {
                this.$router.push({
                  name: "Invoice",
                  params: { invoiceId: notification.InvoiceId },
                });
              } else if (notification.Type == 2) {
                this.$router.push({
                  name: "Ticket",
                  params: { ticketId: notification.TicketId },
                });
              } else if (notification.Type == 3) {
                this.$router.push({
                  name: "Service",
                  params: { serviceId: notification.ServiceId },
                });
              } else {
                window.location.href = notification.Url;
              }
            } else {
              this.$toastr.s(data.Message, "اعلان ها");
            }
          },
          (r) => {}
        );
    },
  },
  computed: {
    computedPage() {
      return {
        activePage: this.page,
      };
    },
    countNotification() {
      if (this.notifications == null) {
        return 0;
      } else {
        var notSeen = 0;
        for (var i = 0; i < this.notifications.length; i++) {
          if (!this.notifications[i].Seen) {
            notSeen++;
          }
        }
        return notSeen;
      }
    },
  },
  mounted() {
    if (this.$store.state.signedIn) {
      this.notifications = this.$store.state.notifications;
      notificationApi.getNotification().then(
        ({ data }) => {
          this.$store.state.notifications = data;
          this.notifications = this.$store.state.notifications;
        },
        (r) => {}
      );
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem;
}

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover,
.btn-transparent:active {
  box-shadow: none !important;
}
</style>
